export interface Props{
  filters: any
}

export interface ResourceResponse {
  count: number
  surveys: Survey[]
}

export interface Survey {
	id: string,
	date: Date| string
	surveyType: string
}

export interface TableData {
  date: string
	id: string
  key: number
	surveyType: string
}
export enum TabStatus {
	Error = 'error',
	Loaded = 'loaded',
	Loading = 'loading',
}